import { Box, Img, Stack, useColorModeValue } from "@chakra-ui/react";
import Nav from "../components/Nav";
import Signin from "../components/signin/SignIn";
import EmailScreen from "../components/signupSteps/EmailScreen";
import MoreInfoScreen from "../components/signupSteps/MoreInfoScreen";
import OTPScreen from "../components/signupSteps/OTPScreen";
import SignupSteps from "../components/signupSteps/SignupSteps";
import LandingLeftSection from "./LandingLeftSection";
import cartoon from "../assets/Character1.png";
import thelogo from "../assets/thelogo.png";
import { noMobileDisplayStyle } from "../constants";
import { UserProfileContext } from "../context/UserContext";
import UserBio from "../components/signupSteps/UserBio";
import ResetPassword from "./ResetPassword";
import ForgotPassword from "../components/signupSteps/ForgotPassword";
import { useState } from "react";
import Discover from "./dashboard/discover/Discover";
import InterestScreen from "../components/signupSteps/InterestScreen";
import LivePage from "../components/LivePage"


function Live() {
  const textColor = useColorModeValue("#fff", "#fff");
  // Define the currentStep state and prevFunction within the Landing component
  const [currentStep, setCurrentStep] = useState(1);
  const [totalStep, setTotalStep] = useState(0);


  
  return (
    <LivePage/>
  );
}

export default Live;
